<template>
  <div class="wrapper">
    <header class="header">
      <a href="#" class="close" @click.prevent="close">
        <i-icon name="cancel" />
      </a>
      <h3 class="heading">{{ __("Filters for a list of apartments") }}</h3>
    </header>
    <main class="main">
      <i-override-dropdown
        v-for="(item, index) of items"
        :key="index"
        :showClear="true"
        :options="item.options"
        :optionLabel="item.optionLabel"
        :placeholder="item.placeholder"
        v-model="item.selected"
      ></i-override-dropdown>
    </main>
    <div class="actions p-fluid">
      <p-vue-button
        class="p-button p-button-outlined p-button-rounded p-button-success"
        @click="filter"
      >
        <span class="p-button-text">{{ __("Filter") }}</span>
      </p-vue-button>
    </div>
  </div>
</template>

<script>
import { __ } from "@/plugins/i18n/";

export default {
  props: {
    close: {
      type: Function,
      default: () => false,
    },
    apartments: {
      type: Array,
    },
  },
  emits: ["filter"],
  data() {
    return {
      items: {
        entrance: {
          selected: null,
          placeholder: `${__("Entrance")}:`,
          options: [],
        },
        apartment: {
          selected: null,
          placeholder: `${__("Apartment")}:`,
          options: [],
        },
        thereIsAdebt: {
          selected: null,
          optionLabel: "label",
          placeholder: `${__("There is a debt")}:`,
          options: [
            { value: false, label: __("No") },
            { value: true, label: __("Yes") },
          ],
        },
      },
    };
  },
  mounted() {
    this.apartments.forEach((element) => {
      if (!this.items.entrance.options.find((f) => f == element.Entrance))
        this.items.entrance.options.push(element.Entrance);
      if (!this.items.apartment.options.find((f) => f == element.Number))
        this.items.apartment.options.push(element.Number);
    });
  },
  methods: {
    filter() {
      this.$emit('filter', this.items)
      this.close()
    }
  },
};
</script>

<style scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  min-height: 95vh;
  max-height: 100vh;
}

.header {
  top: 0;
  z-index: 2;
  position: sticky;
  position: -webkit-sticky;
  background-color: white;
  padding: 20px;
}

.close {
  position: absolute;
  left: calc(100% + 30px);
  color: white;
}

.close .svg {
  width: 21px;
  height: 21px;
}

.heading {
  margin: 0;
  line-height: 1;
  font-size: 26px;
  font-weight: normal;
  color: var(--color-primary);
}

.main {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0 20px 20px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.main:deep(.p-dropdown:not(:last-child)) {
  margin-bottom: 20px;
}

.actions {
  padding: 20px;
}
</style>
